import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            A pure function does not necessarily need all inputs passed-in as parameters 
            because a pure function calling other pure functions remains pure itself.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            Correct, all parameters must be passed-in as arguments but a pure 
            function can call other pure functions and still maintain referential transparency.
        </p>
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QArgs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Is everything a pure function needs passed-in as arguments?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QArgs;


// WEBPACK FOOTER //
// ./src/components/q_args.js